






















import { Vue, Component, Prop } from 'vue-property-decorator';

import { mapGetters } from "vuex";

type Value = string | number;

@Component({
  computed: {
    ...mapGetters('explorer', { labelsForModelGroupedByParent: 'labelsForModelGroupedByParent' }),
  },
})
export default class LabelsDropdown extends Vue {
  @Prop(String) model: 'route' | 'event' | 'destination';
  @Prop({ type: [Array, Object, Number, String], default: null }) value: Value[] | Value | null;

  isSelected (value: Value) : boolean {
    if (Array.isArray(this.value)) {
      return this.value.includes(value);
    }

    return false;
  }

  toggleLabel (label: Types.Label) {
    if (Array.isArray(this.value)) {
      const newValue = this.isSelected(label.id)
        ? [...this.value.filter(value => value !== label.id)]
        : [...this.value, label.id];
      this.$emit('input', newValue);
    }
  }
}
